module.exports = __webpack_public_path__ + "media/story_completed.9f92a41b.wav";